import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loadable from "react-loadable";
import "../../node_modules/font-awesome/scss/font-awesome.scss";
import Loader from "./layout/Loader/SpinnerSvg";
import Aux from "../hoc/_Aux";
import routes from "../route";
import SocketClient from "../App/components/Socket/SocketCLient";

const AdminLayout = Loadable({
    loader: () => import("./layout/AdminLayout"),
    loading: Loader
    // delay: 3000,
});

const App = () => {
    const menu = routes.map((route, index) => {
        return route.component ? (
            <Route
                key={index}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={(props) => <route.component {...props} />}
            />
        ) : null;
    });

    return (
        <Aux>
            <SocketClient />
            <div className="main-body">
                <div className="page-wrapper">
                    <Suspense fallback={<Loader />}>
                        <Switch>
                            {menu}
                            <Route path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </div>
            </div>
        </Aux>
    );
};

export default App;
